<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <page-template page-id="session-revocation-success-page" ref="super">
    <document-title :title="$tb('pages.sessionRevokeStatus.outcomeTitle')"></document-title>

    <template v-slot:before v-if="isTitlebarActive">
      <titlebar :text="$t('pages.sessionRevokeStatus.outcomeTitle')"></titlebar>
    </template>

    <div class="ui column">

      <h4 class="custom-ui header">{{ $t('pages.sessionRevokeStatus.outcomeHeader') }}</h4>
      <p>{{ $t('pages.sessionRevokeStatus.outcomeSubHeader') }}</p>

      <messages id="Notifications" ref="postman"></messages>

    </div>

  </page-template>
</template>

<script>
import PageTemplate from './template/PageTemplate.vue'
import Titlebar from '../components/Titlebar.vue'
import Messages from '../components/Messages.vue'
import { mixin } from '../js/ciam-mixin.js'
import { brand } from '../js/brand.js'

export default {
  components: {
    PageTemplate,
    Titlebar,
    Messages
  },
  mixins: [mixin, brand],
  props: {
    outcome: {
      type: String,
      default: ''
    }
  },
  mounted: function () {
    console.log(`Session Revocation Status(Outcome: ${this.outcome})`)
  }
}
</script>

<style scoped>
</style>
